import { render, staticRenderFns } from "./header-client.vue?vue&type=template&id=6e5d00ec&scoped=true"
import script from "./header-client.vue?vue&type=script&lang=js"
export * from "./header-client.vue?vue&type=script&lang=js"
import style0 from "./header-client.vue?vue&type=style&index=0&id=6e5d00ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d00ec",
  null
  
)

export default component.exports